module.exports = __webpack_public_path__ + "static/media/loadPdf.336043c8.gif";